import { Text } from 'ui/Typography';

type Props = {
  children: React.ReactNode;
};

const StepDescription: React.FC<Props> = ({ children }) => (
  <Text fontSize="sm" color="gray.700" mb={6}>
    {children}
  </Text>
);

export default StepDescription;
